import { CommonModule, NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PreviewBlockHelper } from '../../../../../utils/preview-block-helper';
import { BasePreviewShellComponent } from '../../google-templates/preview-common/base-preview-shell.component';
import { PreviewVariant } from '../../google-templates/preview-common/preview-variant.interface';
import { MetaCarouselPreviewData, MetaCarouselCardPreviewData } from '../../../../../models/meta-template/preview-interfaces/meta-carousel-preview-data.interface';
import { META_CAROUSEL_VARIANTS } from './variants/meta-carousel-variants';

/**
 * Meta Carousel Ad preview. The selector mechanics live in
 * {@link BasePreviewShellComponent}; this class supplies the variant registry
 * and how to build the flat {@link MetaCarouselPreviewData} DTO from the blocks.
 *
 * To add a placement, register it in `META_CAROUSEL_VARIANTS`.
 */
@Component({
  selector: 'app-meta-carousel-preview',
  imports: [CommonModule, NgComponentOutlet],
  templateUrl: '../../google-templates/preview-common/base-preview-shell.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../google-templates/preview-common/base-preview-shell.component.scss'
})
export class MetaCarouselPreviewComponent extends BasePreviewShellComponent<MetaCarouselPreviewData> {
  protected readonly registry: PreviewVariant[] = META_CAROUSEL_VARIANTS;

  protected buildPreviewData(): MetaCarouselPreviewData {
    return {
      primaryText: PreviewBlockHelper.getVar(PreviewBlockHelper.findBlock(this.blocks, 'meta-carousel-primary-text'), 'PrimaryText').trim(),
      ctaText: PreviewBlockHelper.getVar(PreviewBlockHelper.findBlock(this.blocks, 'meta-carousel-cta-text'), 'Text').trim(),
      accountType: PreviewBlockHelper.getVar(PreviewBlockHelper.findBlock(this.blocks, 'meta-carousel-account-type'), 'AccountType').trim(),
      cards: this.blocks
        .filter((b) => b.name === 'meta-carousel-card')
        .map((card): MetaCarouselCardPreviewData => ({
          headline: PreviewBlockHelper.getVar(card, 'Headline').trim(),
          url: this.toAbsoluteUrl(PreviewBlockHelper.getVar(card, 'Link')),
          format: PreviewBlockHelper.getVar(card, 'Format') === 'Video' ? 'Video' : 'Image',
          media: PreviewBlockHelper.getVar(card, 'Media').trim(),
        })),
    };
  }

  /** Prefix a scheme so an `[href]` does not resolve against the editor's origin. */
  private toAbsoluteUrl(rawUrl: string): string {
    const url = rawUrl.trim();
    if (!url) {
      return '';
    }
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  }
}
